TS.ns('WL');

WL.reportsViewModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this,
            paramsList,
            reportType;
        me.parent(config);

        paramsList = me.getDomainProperty('dgReportParameterCollection_Property');
        if (paramsList) {
            paramsList.on('cellValueChanged', me.onParamsListChanged);
        }

        reportType = me.getDomainProperty('lkpReportType_Property');
        if (reportType) {
            reportType.on('selectionChanged', me.onReportTypeChanged)
        }
    },

    initialize: function (config) {
        var me = this;
        me.parent(config);

        me.isSimpleGridReport = ko.computed(function () {
            return me.Document.ReportType() == 'Simple grid';
        });
        me.isNotSimpleGridReport = ko.computed(function () {
            return me.Document.ReportType() != 'Simple grid';
        });
    },

    onParamsListChanged: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName != 'ReportParameterTypeId')
            return;
        
        owner.performServerCommand({
            cmd: 'RefreshReportParameters',
            submitModel: true,
            blockUI: true,
            extraData: { rowIdx: e.rowIdx, paramTypeId : e.record.ReportParameterTypeId() }
        });
    },
    onReportTypeChanged: function (e) {
        var me = this,
            owner = me._getOwner();

        if (owner.isSimpleGridReport()) {
        }
        else {
            owner.Document.StoredProcedureName(null);
        }
    }
});